import CONSTANTS from 'utils/constants';
import _ from 'ckLodash';
import elementUtils from 'utils/elementUtils';
import findElementUtils from 'utils/findElementUtils';
import rangeUtils from 'utils/rangeUtils';
import selectionUtils from 'utils/selectionUtils';
import utils from 'utils/utils';

function getGuard(blockElement) {
    var guard = blockElement.$.querySelector('.wixGuard');
    return guard && new CKEDITOR.dom.element(guard);
}

function hasGuard(blockElement) {
    return !!blockElement.$.querySelector('.wixGuard');
}

function getAllGuards(editor, block) {
    block = block || editor.editable();
    var guards = block.$.querySelectorAll('.wixGuard');
    return _.map(guards, function (guardElem) {
        return new CKEDITOR.dom.element(guardElem);
    });
}

//todo - rename to unused\redundant
function removeUneededGuards(editor) {
    var guards = _.filter(getAllGuards(editor), function (guard) {
        var block = utils.getBlockParent(new CKEDITOR.dom.elementPath(guard));
        if (!elementUtils.isElementTextEmpty(block)) {
            return true;
        }

        var guardsInBlock = getAllGuards(editor, block);
        //if there is more than one guard in textblock we should remove all but first
        //( happens when backspace/delete in neighboring empty blocks
        return guardsInBlock.length && guardsInBlock[0].getUniqueId() !== guard.getUniqueId();
    });

    _.forEach(guards, function (guard) {
        removeGuard(editor, guard);
    });
}


function insertGuard(editor, blockElement, refNode, isAfterRefNode) {
    if (hasGuard(blockElement)) {
        return;
    }

    if (!refNode) {
        refNode = findElementUtils.findFirstNonEmptyTextNode(editor, blockElement);
        isAfterRefNode = false;
    }
    var element = new CKEDITOR.dom.element('span');
    element.setAttribute('class', 'wixGuard');
    element.setText(CONSTANTS.WIX_GUARD);
    if (refNode && isAfterRefNode) {
        element.insertAfter(refNode);
    } else if (refNode) {
        element.insertBefore(refNode);
    } else {
        //append to the beginning (second param is true) of the empty block
        blockElement.append(element, true);
    }
}

function guardInSelection(editor, blockElement) {
    var guard = getGuard(blockElement);
    if (!guard) {
        return false;
    }

    var range = selectionUtils.getSelectedRange(editor);
    if (rangeStartsInGuard(guard, range) || rangeEndsInGuard(guard, range)) {
        return true;
    }

    var walker = new CKEDITOR.dom.walker(range);
    var node;
    while (node = walker.next()) {
        if (node.getUniqueId() === guard.getUniqueId()) {
            return true;
        }
    }
    return false;
}

function isRangeEndAfterGuard(editor, guard, range, blockElement) {
    if (!selectionUtils.selectionEndsInSameBlockAsElement(editor, guard)) {
        return true;
    }
    var walkerRange = new CKEDITOR.dom.range(editor.editable());
    var endContainerCheck = range.endContainer;
    //if range is endContainer = p endOffset = 2 and data is as follows
    //<p><span>a</span><span**>b</span></p>
    //then we want endContainer to be <span**> and not <p>
    if (endContainerCheck.type !== CKEDITOR.NODE_TEXT) {
        var childCount = endContainerCheck.getChildCount();
        if (range.endOffset === childCount) {
            endContainerCheck = endContainerCheck.getChild(range.endOffset - 1);
        } else {
            endContainerCheck = endContainerCheck.getChild(range.endOffset);
        }
    }
    range.selectNodeContents(blockElement);
    var walker = new CKEDITOR.dom.walker(walkerRange);
    var node;
    while (node = walker.next()) {
        if (node.getUniqueId() === guard.getUniqueId()) {
            return false;
        } else if (node.getUniqueId() === endContainerCheck.getUniqueId()) {
            return true;
        }
    }
    // if we get here then first call to walker.next() returned null. assuming false is safe
    return false;
}

function moveSelectionAfterGuard(editor, blockElement, forceCollapse) {
    var guard = getGuard(blockElement);
    if (!guard) {
        return;
    }
    var range = selectionUtils.getSelectedRange(editor);
    var collapsed = range.collapsed;
    if (collapsed || forceCollapse || !isRangeEndAfterGuard(editor, guard, range, blockElement)) {
        range.setStartAfter(guard);
        range.collapse(true);
    } else {
        range.setStartAfter(guard);
    }
    range.select();
}

function setCursorAfterGuard(editor, blockElement) {
    var guard = getGuard(blockElement);
    if (!guard) {
        return;
    }
    var range = new CKEDITOR.dom.range(editor.editable());
    range.setStartAfter(guard);
    range.collapse(true);
    range.select();
}

function setCursorBeforeGuard(editor, blockElement) {
    var guard = getGuard(blockElement);
    if (!guard) {
        return;
    }
    var range = new CKEDITOR.dom.range(editor.editable());
    range.setStartBefore(guard);
    range.collapse(true);
    range.select();
}


function selectGuard(editor, guard) {
    if (!guard) {
        return;
    }

    var range = new CKEDITOR.dom.range(editor.editable());
    range.setStartBefore(guard);
    range.setEndAfter(guard);
    range.select();
}

function expandSelectionToGuard(editor, blockElement) {
    //we assume that if there is a guard then textBlock is empty
    //if this assumption is wrong then we will take the wrong decision
    //we avoid this by making sure that this assumption is correct
    removeUneededGuards(editor);
    var guard = getGuard(blockElement);
    if (!guard) {
        return;
    }
    var range = selectionUtils.getSelectedRange(editor);

    if (rangeUtils.isRangeInsideElement(range, blockElement)) {
        selectGuard(editor, guard);
    } else {
        range.setStartBefore(guard);
        range.select();
    }
}


function rangeEndsInGuard(guard, range) {
    return range.endContainer.getUniqueId() === guard.getUniqueId() ||
        range.endContainer.getParent().getUniqueId() === guard.getUniqueId();
}

function rangeStartsInGuard(guard, range) {
    return range.startContainer.getUniqueId() === guard.getUniqueId() ||
        range.startContainer.getParent().getUniqueId() === guard.getUniqueId();
}

function removeGuard(editor, guard) {
    var range = selectionUtils.getSelectedRange(editor);
    if (rangeStartsInGuard(guard, range)) {
        range.setStartBefore(guard);
    }
    if (rangeEndsInGuard(guard, range)) {
        range.setEndAfter(guard);
    }
    //todo check if double ckguard is caused by bookmark
    //todo if range is not anchored in text node and guard.previous is text node anchor it there
    //todo if range is not anchored in text node and guard.previous is guard then anchor it there
    //todo if range is not anchored in text node and block element has previous text node then achor it there
    var bookmark = selectionUtils.createBookmark(editor);
    var guardHtml = guard.getHtml();
    if (guardHtml !== CONSTANTS.WIX_GUARD) {
        // we shouldn't really go in here but ... shit happens
        // case <p>GUARD{</p><p>a}</p> press LETTER we happen to be here on key up.
        var frag = utils.getCKDocumentFragment(utils.removeGuardsChars(guardHtml));
        frag.replace(guard);
    } else {
        guard.remove();
    }
    selectionUtils.moveToBookmark(editor, bookmark);
}

function removeGuardIfSafe(editor, blockElement) {
    var guard = getGuard(blockElement);
    if (!guard) {
        return;
    }

    if (elementUtils.isElementTextEmpty(blockElement)) {
        return;
    }

    removeGuard(editor, guard);
}

function transformGuardForSetData(htmlStr) {
    return htmlStr.replace(/<span class="wixGuard">.*?<\/span>/g, '<span class="wixGuard">' + CONSTANTS.WIX_GUARD + '<\/span>');
}

export default {
    expandSelectionToGuard: expandSelectionToGuard,
    getAllGuards: getAllGuards,
    getGuard: getGuard,
    guardInSelection: guardInSelection,
    hasGuard: hasGuard,
    insertGuard: insertGuard,
    moveSelectionAfterGuard: moveSelectionAfterGuard,
    removeGuardIfSafe: removeGuardIfSafe,
    selectGuard: selectGuard,
    setCursorAfterGuard: setCursorAfterGuard,
    setCursorBeforeGuard: setCursorBeforeGuard,
    transformGuardForSetData: transformGuardForSetData,
    removeUneededGuards: removeUneededGuards
};
